// extracted by mini-css-extract-plugin
export var bottom = "bH_s";
export var contact = "bH_g2";
export var faqCat = "bH_g9";
export var faqCatDescription = "bH_hd";
export var faqCatTitle = "bH_hc";
export var faqCategories = "bH_g8";
export var faqIcon = "bH_hb";
export var footerText = "bH_cl";
export var icon = "bH_bz";
export var iconContainer = "bH_bP";
export var iconText = "bH_g4";
export var immediate = "bH_g3";
export var inputContainer = "bH_cV";
export var linksSubtitle = "bH_g6";
export var linksTitle = "bH_g5";
export var search = "bH_cv";
export var searchInput = "bH_cW";
export var section = "bH_b";
export var selected = "bH_bg";
export var supportButton = "bH_hf";
export var supportLinks = "bH_g7";
export var top = "bH_l";
export var wave = "bH_g1";